import { render, staticRenderFns } from "./CustomExtensionInfoModal.vue?vue&type=template&id=2896dd8a&scoped=true&"
import script from "./CustomExtensionInfoModal.vue?vue&type=script&lang=ts&"
export * from "./CustomExtensionInfoModal.vue?vue&type=script&lang=ts&"
import style0 from "./CustomExtensionInfoModal.vue?vue&type=style&index=0&id=2896dd8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2896dd8a",
  null
  
)

export default component.exports